<template>
  <div>
    <label :for="handle">{{ label }}</label>
    <v-select @input="change" label="label"
              :options="options"
              :disabled="disabled"
              v-model="selectedValue"
              :key="'fclr-'+handle+'-'+changeCounter"
              :placeholder="placeholder"
              :multiple="multiple"
              :class="inputClass">
      <span slot="no-options">Filteroptionen werden geladen...</span>
      <div slot="open-indicator" class="vs__open-indicator"></div>
    </v-select>
  </div>
</template>
<style></style>
<script>
export default {
  name: "filter-criteria-list-range",
  props: {
    label: String,
    handle: String,
    criteriaId: Number,
    disabled: Boolean,
    inputClass: String,
    placeholder: String,
    value: [ Object, Boolean ],
    optionsEndpoint: [ String, Boolean ],
    multiple: Boolean,
    optionsInit: Array
  },
  computed: {
    completeOptionsEndpoint: function () {
      if(this.optionsEndpoint){
        return this.optionsEndpoint.replace('{code}', this.criteriaId);
      }
      return null;
    }
  },
  data: function () {
    return {
      selectedValue: this.value,
      changeCounter: 0,
      options: []
    }
  },
  methods: {
    getOptions: function () {
      var self = this;
      axios.get(this.completeOptionsEndpoint)
          .then(function(response){
            self.options = response.data;
            self.setSelected();
          });
    },
    setSelected: function(){
      if(this.options && this.value && !this.value.label){
        var sel = this.options.find(f =>(f.min == this.value.min));
        if(sel){
          this.selectedValue = sel;
        }
      }
    },
    change: function(event){
      if(this.selectedValue && this.selectedValue.label === 'Beliebig'){
        this.selectedValue = null;
      }
      this.changeCounter++;
      this.$emit('input', event);
    }
  },
  updated() {
    this.setSelected();
  },
  mounted() {
    if(this.optionsEndpoint){
      this.getOptions();
    } else {
      this.options = this.optionsInit;
    };
  }
}
</script>